export default "__VITE_ASSET__BMHYRUgx__"